export const createProfileUrl = (url: string) => `/profile/api${url}`;
